import React from 'react';

import { Text } from '@betterment/samba-react';
import { Button, Flex, Heading } from '@betterment/style-closet-react';

// eslint-disable-next-line @typescript-eslint/unbound-method
const PendingSwitchSpendingAccount: React.FC<React.PropsWithChildren<{ onClose(): void }>> = ({ onClose }) => (
  <Flex flexDirection="column" alignItems="flex-start">
    <Heading variant="secondary" textAlign="left" pb="3">
      Your spending account is in the process of switching
    </Heading>
    <Text
      as="p"
      css={{
        textAlign: 'left',
        marginBottom: 'space.200',
        _last: { marginBottom: 'space.0' },
      }}
    >
      Your spending account will update within one hour from when you initiated the switch. You will not be able to
      request another change until the update is complete.
    </Text>
    <Text
      as="p"
      css={{
        textAlign: 'left',
        marginBottom: 'space.400',
      }}
    >
      You can continue to use your Betterment Visa&reg; Debit Card with your current spending account.
    </Text>
    <Button onClick={onClose} px="11">
      Got it
    </Button>
  </Flex>
);

export default PendingSwitchSpendingAccount;
